// extracted by mini-css-extract-plugin
module.exports = {"feature":"FeaturesTypeFourth_feature__2o512","title":"FeaturesTypeFourth_title__31DXE","col":"FeaturesTypeFourth_col__1Pahv","leftCol":"FeaturesTypeFourth_leftCol__1Vr7x"};